import React from "react";
import { useNavigate } from "react-router-dom";

const BotStrength = () => {
  const navigate = useNavigate();

  return (
    <section>
      <div className="w-full max-w-[1320px] mx-auto px-5 pt-14">
        <h2 className="text-center text-[28px] text-[#21272A] font-bold">
          Bot Strength
        </h2>

        {/* main */}
        <div className="grid md:grid-cols-2 gap-3 mt-6">
          {/* left */}
          <div className=" gap-3">
            {/* row 1 */}
            <div className=" bg-[#302571] text-white p-6 rounded-xl relative h-[200px] md:h-[245px] lg:h-[185px] xl:h-[195px] mb-3">
              <h4 className="text-xl font-bold">Thrives in Volatility</h4>
              <span className="text-sm font-normal block max-w-[300px]  opacity-85 mt-2">
                Capitalizes on price swings to secure profitable trades.
              </span>
              <img
                src="/images/illustrations/bitcoin-rail.svg"
                alt=""
                className="absolute max-xl:max-w-[150px]  right-10 bottom-[2px]"
              />
            </div>
            {/* end row 1 */}
            <div className="border border-[#DDE1E6] p-6 rounded-xl flex gap-6 lg:gap-16">
              <img
                src="/images/illustrations/like-thunder.svg"
                alt=""
                className="max-md:w-full "
              />
              <div>
                <h4 className="text-xl font-bold">Safety of Spot Trading</h4>
                <span className="text-sm font-normal block opacity-85 mt-2">
                  Operates without margin trading risk, keeping your assets
                  safe.
                </span>
              </div>
            </div>
          </div>
          {/* end left */}
          {/* right */}
          <div className="gap-3">
            <div className="border border-[#DDE1E6] p-6 rounded-xl flex items-center gap-6 lg:gap-20 lg:justify-between">
              <div>
                <h4 className="text-xl font-bold">Market Independence</h4>
                <span className="text-sm font-normal block  opacity-85 mt-2">
                  Works without relying on market direction.
                </span>
              </div>
              <img
                src="/images/illustrations/scales.svg"
                alt=""
                className="max-lg:w-full lg:max-w-[130px]"
              />
            </div>
            {/* row 2 */}
            <div className=" bg-[#DDE1E6] p-6 rounded-xl mt-3">
              <img src="/images/illustrations/sleep-bot.svg" alt="" />
              <h4 className="text-xl font-bold max-lg:mt-4">24/7 Automation</h4>
              <span className="text-sm font-normal block opacity-85  mt-2">
                24/7 automation means no missed opportunities.
              </span>
            </div>
            {/* end row 2 */}
          </div>
          {/* end right */}
        </div>
        {/* end mmain */}
        <div className="flex justify-center mt-6">
          <button
            className="w-full max-w-[500px] relative overflow-hidden !py-4 !font-bold !text-xl bg-teal-700 hover:bg-teal-800 mt-4  rounded-xl"
            onClick={() => navigate("/signup")}
          >
            Activate
          </button>
        </div>
      </div>
    </section>
  );
};

export default BotStrength;
